import { Lang } from "@/i18n/settings";
import countries_ar from "./data-ar.json";
import countries_en from "./data-en.json";

type Country = {
  id: number;
  alpha2: string;
  alpha3: string;
  name: string;
};

// Define types for the maps
type ValueMap = {
  [key: string]: string;
};

class CountryList {
  data: Country[];
  labelMap: ValueMap;
  ar_ValueMap: ValueMap;
  en_ValueMap: ValueMap;
  alpha2Map: ValueMap;

  constructor(lang: Lang) {
    if (lang === "ar") {
      this.data = countries_ar.sort((a, b) =>
        a.name.localeCompare(b.name),
      ) as Country[];
    } else {
      this.data = countries_en.sort((a, b) =>
        a.name.localeCompare(b.name),
      ) as Country[];
    }

    this.labelMap = {};
    this.en_ValueMap = {};
    this.ar_ValueMap = {};
    this.alpha2Map = {};

    this.data.forEach((country) => {
      const lowerCaseValue = country.alpha2.toLowerCase();
      this.labelMap[lowerCaseValue] = country.alpha2;
      this.ar_ValueMap[lowerCaseValue] = country.name;
      this.alpha2Map[lowerCaseValue] = country.alpha2;
      // this.en_ValueMap?.[lowerCaseValue] = country.name_EN;
    });
  }

  getValues(): string[] {
    return this.data.map((country) => country.name);
  }

  getAlpha2List(): string[] {
    const obj = this.alpha2Map;

    const toArr = Object.entries(obj).map(([key]) => {
      return key?.toUpperCase();
    });

    return toArr;
  }

  getLabelList(): ValueMap {
    return this.en_ValueMap;
  }

  getValueList(): ValueMap {
    return this.en_ValueMap;
  }

  getData(): { label: string; value: string }[] {
    return this.data.map((country) => ({
      label: country.name,
      value: country.alpha2,
    }));
  }
}

// Factory function to create a new instance if needed
function countryList(lang: Lang): CountryList {
  return new CountryList(lang);
}

export default countryList;
